var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 154,
    viewBox: "0 0 154 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 77,
    cy: 77,
    r: 77,
    fill: "#F0F5F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.899 67.5761V55.9452C107.899 53.7448 106.013 51.8587 103.813 51.8587H66.4052L64.5191 46.5148C63.8904 44.943 62.3187 44 60.7469 44H44.0865C41.8861 44 40 45.5717 40 48.0865V52.173V60.3461V109.07L56.6604 70.4052C57.2891 68.8335 58.8609 67.8904 60.4326 67.8904H107.899V67.5761Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.898 67.5742V108.754L123.301 73.2325C124.559 70.4033 122.358 67.5742 119.529 67.5742H107.898Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107.898 67.5742V108.754L123.301 73.2325C124.559 70.4033 122.358 67.5742 119.529 67.5742H107.898Z",
    fill: "url(#paint0_linear_8660_19215)",
    fillOpacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.898 67.5742V108.754L123.301 73.2325C124.559 70.4033 122.358 67.5742 119.529 67.5742H107.898Z",
    fill: "url(#paint1_linear_8660_19215)",
    fillOpacity: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6604 70.089L40 109.068H107.899V67.5742H60.4326C58.8609 67.5742 57.2891 68.8316 56.6604 70.089Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6604 70.089L40 109.068H107.899V67.5742H60.4326C58.8609 67.5742 57.2891 68.8316 56.6604 70.089Z",
    fill: "url(#paint2_linear_8660_19215)",
    fillOpacity: 0.8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6604 70.089L40 109.068H107.899V67.5742H60.4326C58.8609 67.5742 57.2891 68.8316 56.6604 70.089Z",
    fill: "url(#paint3_linear_8660_19215)",
    fillOpacity: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8660_19215",
    x1: 123.664,
    y1: 108.754,
    x2: 96.1638,
    y2: 98.2257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#252117"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8660_19215",
    x1: 107.898,
    y1: 67.5742,
    x2: 135.266,
    y2: 78.2551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#3878f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8660_19215",
    x1: 107.899,
    y1: 109.068,
    x2: 70.9742,
    y2: 48.6455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#252117"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8660_19215",
    x1: 40,
    y1: 67.5742,
    x2: 75.9068,
    y2: 127.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#3878f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.143751193ed3672f06cc8bba7d671364.svg";
export { ForwardRef as ReactComponent };